export const GBIF_BACKBONE_DATASET_KEY = 'd7dddbf4-2cf0-4f39-9b2a-bb099caae36c';
export const CHECKLIST_BANK_DATASET_KEY = 'e007cc4a-8704-449d-8829-bb209d26d6c8';

export const dataGridStyles = {
  "& .MuiDataGrid-cell": { alignItems: "flex-start", whiteSpace: "normal", lineHeight: 1.3 },
  "& .MuiDataGrid-columnHeaderTitle": { whiteSpace: "normal", lineHeight: 1.2 },
};
